export const styles = [
  {
    icon: 'snowflake.svg',
    name: 'Scandy',
    value: 'scandy',
  },
  {
    icon: 'leaf.svg',
    name: 'Boho',
    value: 'boho',
  },
  {
    icon: 'coffee.svg',
    name: 'England',
    value: 'england',
  },
  {
    icon: 'star.svg',
    name: 'Neutral',
    value: 'zero',
  },
  {
    checked: true,
    icon: 'lamp.svg',
    name: 'Modern',
    value: 'modern',
  },
  {
    icon: 'mountain.svg',
    name: 'Japandi',
    value: 'japandi',
  },
  {
    icon: 'crown.svg',
    name: 'Elegance',
    value: 'elegance',
  },
  {
    icon: 'star5.svg',
    name: 'American',
    value: 'american',
  },
];
